import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // ✅ Ajout de Link
import ReCAPTCHA from 'react-google-recaptcha';
import { FiHelpCircle, FiEye, FiEyeOff } from 'react-icons/fi'; // ✅ Ajout de FiHelpCircle
import { ParticlesBackground } from '../../components/ui';
import { TwoFactorVerification } from '../../components/auth';
import { authService } from '../../services/authService';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  
  const [show2FA, setShow2FA] = useState(false); 
  const [userEmail, setUserEmail] = useState('');
  
  const navigate = useNavigate();

  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!recaptchaToken) {
      setError('Veuillez compléter la vérification reCAPTCHA.');
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await authService.login(email, password);
      
      if (result.message === "OTP_SENT") {
        setUserEmail(email); 
        setShow2FA(true);    
      } else {
        setError("Une erreur inattendue est survenue.");
      }
    } catch (err) {
      setError(err || 'Identifiants invalides ou compte verrouillé');
      setRecaptchaToken(null);
      if (window.grecaptcha) window.grecaptcha.reset();
    } finally {
      setIsSubmitting(false);
    }
   };
  

  const handle2FAVerified = (data) => {
    setShow2FA(false);
    if (data.mustChangePassword) {
      navigate('/admin/profile', { 
        state: { message: "Bienvenue ! Pour activer votre compte de manière sécurisée, veuillez définir votre mot de passe définitif." } 
      });
    } else {
      navigate('/admin'); 
    }
  };

  return (
    <div className="login-container-modern">
      <ParticlesBackground />
      
      <form className="login-form-modern" onSubmit={handleSubmit}>
        <div className="text-center mb-4">
            <img src="/images/logo.png" alt="S2I" style={{height: '60px'}} />
            <h2 className="login-title mt-3">Espace Administrateur</h2>
        </div>
        
        {error && <div className="alert alert-danger py-2" style={{fontSize: '0.85rem'}}>{error}</div>}

        <div className="login-field-group">
          <label>Email professionnel</label>
          <input 
            type="email" 
            className="login-input" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
            placeholder="nom@s2i.com.tn" 
            autoComplete="username"
          />
        </div>

        <div className="login-field-group mb-1"> {/* ✅ Réduction de la marge pour coller le lien */}
          <label>Mot de passe</label>
          <div className="login-password-wrapper">
            <input 
              type={showPassword ? 'text' : 'password'} 
              className="login-input" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              autoComplete="current-password"
            />
            <button type="button" className="login-show-btn" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        {/* ✅ AJOUT DU LIEN MOT DE PASSE OUBLIÉ */}
        <div className="text-end mb-3">
          <Link 
            to="/forgot-password" 
            className="forgot-password-link"
            style={{ 
              fontSize: '0.8rem', 
              color: '#64748b', 
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <FiHelpCircle size={14} /> Mot de passe oublié ?
          </Link>
        </div>
        
        <div className="recaptcha-container my-3 d-flex justify-content-center">
          <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={(t) => setRecaptchaToken(t)} />
        </div>
        
        <button type="submit" className="login-submit-btn" disabled={isSubmitting}>
          {isSubmitting ? 'Vérification en cours...' : 'Se connecter'}
        </button>

        <div className="text-center mt-3">
            <small className="text-muted">Accès restreint aux employés S2I</small>
        </div>
      </form>

      <TwoFactorVerification
        show={show2FA}
        onHide={() => setShow2FA(false)}
        onVerified={handle2FAVerified}
        userEmail={userEmail}
      />
    </div>
  );
}

export default Login;